import scoreMain from '@/views/score/scoreMain.vue'
import goodsDetail from '@/views/score/goodsDetail.vue'
import scoreDetail from '@/views/score/scoreDetail.vue'
import orderScoreDetail from '@/views/score/orderScoreDetail.vue'
import scoreCharge from '@/views/score/scoreCharge.vue'
import scoreResult from '@/views/score/result.vue'

export default [
  {
    path: '/scoreMain',
    name: 'ScoreMain',
    component: scoreMain,
    meta: {
      title: '我的积分',
      keepAlive: true, // init 缓存
      isDynamic: true, // 动态缓存
      isApp: true
    }
  },
  {
    path: '/goodsDetail',
    name: 'GoodsDetail',
    component: goodsDetail
  },
  {
    path: '/scoreDetail',
    name: 'ScoreDetail',
    component: scoreDetail,
    meta: {
      title: '积分明细',
      isDynamic: true // 动态缓存
    }
  },
  {
    path: '/orderScoreDetail',
    name: 'OrderScoreDetail',
    component: orderScoreDetail,
    meta: {
      title: '订单详情',
      isDynamic: true // 动态缓存
    }
  },
  {
    path: '/scoreCharge',
    name: 'ScoreCharge',
    component: scoreCharge,
    meta: {
      title: '积分充值',
      isDynamic: true // 动态缓存
    }
  },
  {
    path: '/scoreResult',
    name: 'ScoreResult',
    component: scoreResult,
    meta: {
      title: '兑换结果'
    }
  }
]
